import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import { createURL } from 'utils/createURL';
import sortBy from 'lodash/sortBy';
import NavItem from '../NavItem/NavItem.component'

const StaticNav =  React.memo(function MemoStaticList({
    data,
    pathBase
}){

    let main;

    data.allAsciidoc.edges.filter(item => {
        if(item.node.frontmatter.topindex){
            main = item
            return false
        } 
        return true
    })

    
  function addSubItem(subNavItems, node, splitPath, path, index){
    const nodeTitle = node?.frontmatter?.title ?? 'No Title';
    const nodeUUID = node?.frontmatter?.permalink ??  '';
    const nodeOrder = node?.frontmatter?.order ?? 9999

    if (splitPath[index] === 'index') {
      const rootItem = subNavItems.find(item => item.path === `/${path}`);
      if (rootItem) {
        rootItem.name = nodeTitle;
        rootItem.link = createURL(splitPath, nodeUUID) + `/${kebabCase(nodeTitle)}`; /* eslint-disable-line prefer-template */
        rootItem.order = nodeOrder;
      } else {
        subNavItems.push({
          name: nodeTitle,
          path: `/${path}`,
          link: createURL(splitPath, nodeUUID) + `/${kebabCase(nodeTitle)}`,  /* eslint-disable-line prefer-template */
          order: nodeOrder,
          subItems: [],
        });
      }
    } else if (index === splitPath.length) {
      if (node.frontmatter.topindex) return;
      subNavItems.push({
        name: nodeTitle,
        path: `/${path}`,
        link: createURL(splitPath, nodeUUID) + `/${kebabCase(nodeTitle)}`,  /* eslint-disable-line prefer-template */
        order: nodeOrder,
      });
    } else {


      const pathSegment = splitPath.slice(0, index).join('/');
      const indexPath = `/${pathSegment}/index`;
      const rootItem = subNavItems.find(item => item.path === indexPath);
      if (!rootItem) {
        subNavItems.push({ name: 'unknown', path: indexPath, subItems: [], active: false });
      }

      addSubItem(
        subNavItems.find(item => item.path === indexPath).subItems,
        node,
        splitPath,
        path,
        index + 1,
        subNavItems.find(item => item.path === indexPath).link,
      );
    }
  };

    function createProductNav(node, path, splitPath, navList){
        const basePath = pathBase;

        if (splitPath[0] === basePath) {
          if (splitPath.length >= 2 && node.frontmatter.skip !== 'all') {
            addSubItem(navList, node, splitPath, path, 2)
          }
        }
    }

    function getNavItems(queryData){
        const navList = []
        for(let i = 0; i < queryData.allAsciidoc.edges.length; i++){
            const { node } = queryData.allAsciidoc.edges[i]
            const path = node.paths.from.source.file;
            const splitPath = path.split('/');
            createProductNav(node, path, splitPath, navList)
        }
        return navList
    }

    const navItems = useMemo(() => {
        return getNavItems(data)
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

    const elements = [
        {
            link: `${pathBase}/${main.node.frontmatter.permalink}/${kebabCase(main.node.frontmatter.title)}`,
            name: main.node.frontmatter.title,
            subItems: sortBy(navItems, 'order')
        }
    ]

    return (
      <>
        <ul className="topic-selector static-nav">
            {elements.map(navItem => (
                <NavItem key={navItem.name} navItem={navItem} />
            ))}
        </ul>
      </>
  );
})


StaticNav.propTypes = {
    data: PropTypes.object.isRequired,
    pathBase: PropTypes.string.isRequired
};

export default StaticNav;
